import { render, staticRenderFns } from "./GroupHome.vue?vue&type=template&id=53ca4fe8&scoped=true"
import script from "./GroupHome.vue?vue&type=script&lang=js"
export * from "./GroupHome.vue?vue&type=script&lang=js"
import style0 from "./GroupHome.vue?vue&type=style&index=0&id=53ca4fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca4fe8",
  null
  
)

export default component.exports